// Packages
import PropTypes from 'prop-types';

// Components
import Container from 'components/BTDUI/Container';
import Header from 'components/Header';
import Footer from 'components/Footer';

const ManufacturerViewLayout = ({ children }) => {

	return (
		<div className='ManufacturerViewLayout'>
			
			<Header/>

			<Container>

				{children}

			</Container>

			<Footer/>
        </div>
	)
}

ManufacturerViewLayout.propTypes = {
	children: PropTypes.node,
}

ManufacturerViewLayout.defaultProps = {
	children: null,
}

export default ManufacturerViewLayout;